var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-base"},[_c('PageLoading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',[(!_vm.loading)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }